/**
 * KDTypography — Theme-aware typography wrapper
 */

import { forwardRef } from "react";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";

const KDTypographyRoot = styled(Typography)(({ theme, ownerState }) => {
  const { palette, typography } = theme;
  const { color, textTransform, verticalAlign, fontWeight, opacity, textGradient } = ownerState;

  const getColor = (c) => {
    if (!c || c === "inherit") return "inherit";
    const split = c.split(".");
    const paletteColor = palette[split[0]];
    if (paletteColor) return split[1] ? paletteColor[split[1]] : paletteColor.main;
    return c;
  };

  const fontWeightValue = typography[`fontWeight${fontWeight?.charAt(0).toUpperCase() + fontWeight?.slice(1)}`] || fontWeight;

  const base = {
    opacity,
    textTransform,
    verticalAlign,
    textDecoration: "none",
    color: getColor(color),
    fontWeight: fontWeightValue,
  };

  if (textGradient) {
    return {
      ...base,
      backgroundImage: `linear-gradient(${palette.gradients?.primary?.main || "#5EEAD4"}, ${palette.gradients?.primary?.state || "#0D9488"})`,
      display: "inline-block",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
    };
  }

  return base;
});

const KDTypography = forwardRef(
  ({ color, fontWeight, textTransform, verticalAlign, textGradient, opacity, children, ...rest }, ref) => (
    <KDTypographyRoot
      {...rest}
      ref={ref}
      ownerState={{
        color: color || "dark",
        textTransform: textTransform || "none",
        verticalAlign: verticalAlign || "unset",
        fontWeight: fontWeight || "regular",
        opacity: opacity || 1,
        textGradient: textGradient || false,
      }}
    >
      {children}
    </KDTypographyRoot>
  )
);

KDTypography.displayName = "KDTypography";

export default KDTypography;
